"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMounted = void 0;
var react_1 = require("react");
function useIsMounted(allowTests) {
    if (allowTests === void 0) { allowTests = false; }
    var _a = (0, react_1.useState)(false), mounted = _a[0], setMounted = _a[1];
    (0, react_1.useEffect)(function () {
        if (!allowTests && process.env.NODE_ENV === 'test') {
            return;
        }
        setMounted(true);
    }, [allowTests]);
    return mounted;
}
exports.useIsMounted = useIsMounted;
//# sourceMappingURL=useIsMounted.js.map